<template>
	<div>
		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Insta Sync</v-toolbar-title>

		</v-toolbar>

		<div class="hasToolbar" v-scroll="onScroll">

			<v-list nopadding>
				<v-subheader>Completed: {{syncData.completeCount}}
					<v-spacer></v-spacer>
					Pending: {{syncData.pendingCount}}
				</v-subheader>
				<v-divider></v-divider>
				<div v-for="(item, index) in syncData.items" :key="index">
					<v-list-tile>
						<v-list-tile-title>({{item.itemNumber}}) {{item.objectName}}</v-list-tile-title>
					</v-list-tile>

					<v-divider v-if="syncData.items.length-1 != index"></v-divider>
				</div>

				<div class="pa-3" center-align v-if="!syncData.items">No Pending Items</div>
				
			</v-list>


			<!-- <v-list three-line nopadding>

				<div v-if="listItemObject.totalCount">
					<v-divider></v-divider>
						<v-subheader subheader-dense>{{listItemObject.totalCount}} Items</v-subheader>
					<v-divider></v-divider>
				</div>

				<div v-for="(item, index) in listItemObject.items" :key="index">
					<v-list-tile class="right-subtitle-tile">
					    <v-list-tile-content @click="fn_itemClick(item.transactionId)">
					      <v-list-tile-title class="mb-1">{{toolbarTitle == 'Journal' ? 'Journal' : item.accountLedgerName}}</v-list-tile-title>
					      <v-list-tile-sub-title class="mb-1">
					      	{{item.mergeTransactionNumber}}
					      </v-list-tile-sub-title>
					      <v-list-tile-sub-title>{{item.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
					    </v-list-tile-content>

					    <v-list-tile-action align-flex-end>

					    	<v-btn icon flat @click="fn_getBottomMenu(902, item.transactionId)" v-if="item.status">
					    		<v-icon>more_horiz</v-icon>
					    	</v-btn>

					    	<div class="priamry-label info" v-if="!item.status">Cancelled</div>

					    	<div class="light-opacity-color"><strong>&#8377; {{$root.numberToLocale(item.roundedAmount)}}</strong></div>
					    </v-list-tile-action>
					</v-list-tile>

					<v-divider v-if="listItemObject.items.length-1 != index"></v-divider>
				</div>

				<div padding-all-16 center-align v-if="loadMore">
					<v-progress-circular indeterminate color="primary"></v-progress-circular>
				</div>


			</v-list>

			<div class="display_msg" v-if="!listItemObject.items.length">There are no items</div> -->
		</div>

	</div>
</template>

<script>

	export default{
		data(){
			return{
				syncData:null
			}
		},
		methods:{

			

			fn_loadItems: function() {
				let self = this;
				this.getData("InstaSyncList", null, 
					{
						onSuccess: function (response) {
							console.log(response);
							self.syncData = JSON.parse(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
		    },

		    fn_goBack: function(){
		    	this.$router.go(-1);
		    }
		},
		mounted: function(){
			window.js_globals.fn_onBackPress = this.fn_goBack;
			this.fn_loadItems();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/instasync.vue